import type { TaskRouterOptions } from "~/packages/taskrouter/TaskRouterOptions";

export const getDefaultTaskRouterOptions = (): TaskRouterOptions => ({
    workerOptions: {
        setWorkerOfflineIfDisconnected: true
    }
});
